import { Component } from "react";

import { GrClose } from "react-icons/gr";
import Strategy4InfoBox from "./strategy4InfoBox.jsx";
import Strategy4AddDialog from "./strategy4AddDialog.jsx";
import { FaInfo, FaTrash, FaPlay, FaPause } from "react-icons/fa";

class Strategy4Conditions extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addModalShow: false,
      infoBoxShow: false,
      infoBoxCondition: {},
    }

    this.updateIntervalID = null;
  }

  componentDidMount() {
    var intervalId = setInterval(() => this.props.getConditions(4), 1000);
    this.updateIntervalID = intervalId;
  }

  componentWillUnmount() {
    clearInterval(this.updateIntervalID);
    this.updateIntervalID = null;
  }

  showAddDialog = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.addModalShow = true;
      return newState;
    });
  }

  hideAddDialog = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.addModalShow = false;
      return newState;
    });
  }

  showInfoBox = condition => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.infoBoxShow = true;
      newState.infoBoxCondition = condition;
      return newState;
    });
  }

  closeInfoBox = () => {
    this.setState(prevState => {
      const newState = { ...prevState };
      newState.infoBoxShow = false;
      newState.infoBoxID = null;
      return newState;
    });
  }

  render() {
    console.log(this.props.conditions);

    return (
      <div>
        <div className="card m-2">
          <header className="card-header has-text-centered">
            <h5 className="card-header-title">RSI Algo</h5>
          </header>

          <section className="card-content overflow-auto">
            <table className="table is-striped is-hoverable has-text-centered is-fullwidth">
              <thead>
                <tr>
                  <th align="center">ID</th>
                  <th align="center">Broker</th>
                  <th align="center">Scrip</th>
                  <th align="center">Status</th>
                  <th align="center">Ins</th>
                  <th align="center">Running P&L</th>
                  <th align="center">Booked P&L</th>
                  <th align="center">Start/Stop</th>
                  <th align="center">Squareoff</th>
                  <th align="center">Delete</th>
                  <th align="center">Info</th>
                </tr>
              </thead>
              <tbody>
                {this.props.conditions.map((condition, i) => (
                  <tr key={i}>
                    <th scope="row">{condition.id}</th>
                    <td align="center">{condition.brokerName}</td>
                    <td align="center">{condition.scrip}</td>
                    <td align="center">{condition.status}</td>
                    <td align="center">{condition.enteredIns}</td>
                    <td align="center">{condition.runningPnl}</td>
                    <td align="center">{condition.bookedPnl}</td>
                    <td>
                      {
                        condition.stopped ?
                        <button
                          className="button is-danger"
                          onClick={() => this.props.startCondition(condition.id, 4)}
                        >
                          <FaPlay />
                        </button> :
                        <button
                          className="button is-success"
                          onClick={() => this.props.stopCondition(condition.id, 4)}
                        >
                          <FaPause />
                        </button>
                      }
                    </td>
                    <td align="center">
                      <button
                        className="button is-warning"
                        onClick={() => this.props.handleClosePositions(condition.id, 4)}
                      >
                        <GrClose />
                      </button>
                    </td>
                    <td align="center">
                      <button
                        className="button is-danger"
                        onClick={() => this.props.handleConditionDelete(condition.id, 4)}
                      >
                        <FaTrash />
                      </button>
                    </td>
                    <td align="center">
                      <button className="button is-info" onClick={() => this.showInfoBox(condition)}>
                        <FaInfo />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          <footer className="card-footer">
            <button className="card-footer-item button is-link" onClick={() => this.props.getConditions(4)}>Refresh</button>
            <button className="card-footer-item button is-primary" onClick={this.showAddDialog}>Add Condition</button>
          </footer>
        </div>

        <Strategy4AddDialog
          brokers={this.props.brokers}
          open={this.state.addModalShow}
          hideAddDialog={this.hideAddDialog}
          addCondition={this.props.addCondition}
        />
        <Strategy4InfoBox
          show={this.state.infoBoxShow}
          handleClose={this.closeInfoBox}
          condition={this.state.infoBoxCondition}
        />
      </div>
    );
  }
}

export default Strategy4Conditions;